import { getDashboardPathForRoles } from "../utils/dashboardAccess";

/**
 * Role-aware landing route after successful authentication.
 *
 * NOTE (wave-2 remediation): this module once held an analytics-FREE
 * completeAuthenticatedSession twin. Nothing imported it (the live, wired
 * one lives in ./handleLoginSuccess.ts) and keeping it around was a re-armed
 * dark-session trap — deleted. Only this path helper is consumed.
 */
export function getPostLoginPath(roles: string[] | undefined): string {
  if (Array.isArray(roles) && roles.includes("SPOC")) {
    return "/spoc-tasks";
  }

  const dashboardPath = getDashboardPathForRoles(roles);
  if (dashboardPath) {
    return dashboardPath;
  }

  return "/my-leads";
}
